import { render, staticRenderFns } from "./FullTemplate.vue?vue&type=template&id=1564d9c5&"
import script from "./FullTemplate.vue?vue&type=script&lang=js&"
export * from "./FullTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports